import { render, staticRenderFns } from "./EmailLog.vue?vue&type=template&id=60d2b8f1"
import script from "./EmailLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailLog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports